export default __webpack_public_path__ + "static/media/plus-svgrepo-com.b893adf8.svg";